import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'src/auth/useAuth';

function LoginPage() {
  const { t } = useTranslation();
  const { clearError, error, isConfigured, login, status } = useAuth();
  const redirectStartedRef = useRef(false);

  const resolvedError = (() => {
    if (!isConfigured) return t('eris.login.configError');
    if (status === 'token_expired') return t('eris.login.tokenExpired');
    if (status === 'callback_error') return error || t('eris.login.callbackError');
    return error;
  })();

  useEffect(() => {
    if (redirectStartedRef.current) return;
    if (!isConfigured) return;
    if (status === 'loading' || status === 'callback_error') return;

    redirectStartedRef.current = true;
    clearError();
    login();
  }, [clearError, isConfigured, login, status]);

  if (!isConfigured || status === 'callback_error') {
    return <div className="p-6 text-center text-sm text-red-600">{resolvedError}</div>;
  }

  return null;
}

export default LoginPage;
